import LangEnum from '../../../lang/LangEnum';
import snackbarStore from '../../../stores/Snackbar.store';
import { useTranslation } from '../../translation/TranslationContext';
import { RachelFileValidationError } from '../rachel.files';
import { useRachelAttachments } from './useRachelAttachments';

const VALIDATION_ERROR_LANG: Record<RachelFileValidationError, LangEnum> = {
  [RachelFileValidationError.TYPE_NOT_ALLOWED]: LangEnum.RACHEL_FILE_TYPE_NOT_ALLOWED,
  [RachelFileValidationError.TOO_LARGE]: LangEnum.RACHEL_FILE_TOO_LARGE,
};

export const useRachelAttachmentsValue = () => {
  const { translate } = useTranslation();

  return useRachelAttachments({
    onValidationError: (error) =>
      snackbarStore.handleMessage({
        type: 'error',
        message: translate(VALIDATION_ERROR_LANG[error]),
      }),
    onUploadError: () =>
      snackbarStore.handleMessage({
        type: 'error',
        message: translate(LangEnum.RACHEL_FILE_UPLOAD_FAILED),
      }),
  });
};
